<smart-modal [Id]="'ShareJobModal'" [Title]="'Share Job'">
  <div modal-body>
    <div class="container-fluid" *ngIf="RecommendationModel.RecommendedId">
      <label class="form-group" *ngIf="RecommendationModel?.RecommendedId"><b>Recommended
          {{ RecommendationModel?.Title }} Id:</b> {{ RecommendationModel.RecommendedId }}</label>
      <input type="text" name="emailId" [(ngModel)]="RecommendationModel.RecommendedtoEmail" class="form-control"
        placeholder="Enter email to send recommendation" />
      <br>
      <div class="text-center">
        <a class="btn btn-sm btn-primary" on-click="SendRecommendationToUser()" title="Recommended">Recommend</a>
      </div>
    </div>
    <br>
    <social-share *ngIf="PostUrl" [PostUrl]="PostUrl"></social-share>
  </div>
</smart-modal>